import React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import Modal from '../../components/Modal';
import LoadingSpinner from '../../components/LoadingSpinner';
import BtnFilled from '../../components/BtnFilled';
import { usePaymentsStore } from './state/use-payments-store';

const formatAmount = (amount) => {
  const value = Number(amount);
  if (!amount || Number.isNaN(value)) return '-';
  return `${value.toLocaleString('ru-RU')} ₽`;
};

const PaymentRequired = ({ paymentData }) => {
  const { payment, device_ids } = paymentData;
  const handlePay = () => window.open(payment.confirmation_url, '_blank', 'noopener,noreferrer');

  return (
    <div className="space-y-5">
      <div className="flex items-start gap-x-3 p-4 rounded-2xl bg-orange-50">
        <WarningAmberRoundedIcon className="text-orange-500" />
        <div className="space-y-1">
          <p className="font-semibold text-gray-800">Устройство заблокировано</p>
          <p className="text-sm text-gray-600">Причина: закончился NB-IoT пакет</p>
          {device_ids?.length > 0 && <p className="text-xs text-gray-500">ID устройств: {device_ids.join(', ')}</p>}
        </div>
      </div>

      <div className="text-center">
        <p className="text-sm text-gray-500">К оплате:</p>
        <p className="text-3xl font-semibold text-gray-900">{formatAmount(payment.amount)}</p>
      </div>

      <BtnFilled title="Оплатить" btnCb={handlePay} disabled={!payment.confirmation_url} />

      <p className="text-xs text-center text-gray-500">Разблокировка будет после подтверждения оплаты системой</p>
    </div>
  );
};

const PaymentModal = () => {
  const { showPaymentModal, closePaymentModal, isCheckingPayment, paymentModalError, isPaymentRequired, paymentData } = usePaymentsStore();

  const renderContent = () => {
    if (isCheckingPayment) return { title: 'Проверка оплаты', body: <LoadingSpinner loading={true} style="flex items-center justify-center" /> };

    if (paymentModalError) return { title: 'Ошибка', body: <p className="text-red-500">{paymentModalError}</p> };

    if (isPaymentRequired === false) {
      return {
        title: 'Проверка оплаты',
        body: (
          <p className="flex items-center gap-x-2 text-green-600">
            <CheckCircleIcon fontSize="small" />
            Оплата не требуется
          </p>
        ),
      };
    }

    if (paymentData) return { title: 'Требуется оплата', body: <PaymentRequired paymentData={paymentData} /> };

    return { title: 'Проверка оплаты', body: <p className="text-gray-500">Не удалось определить необходимость оплаты.</p> };
  };

  const { title, body } = renderContent();

  return (
    <Modal
      showModal={showPaymentModal}
      setShowModal={closePaymentModal}
      title={title}
      showSave={false}
      style={1}
      classWidth="relative w-11/12 max-w-md my-6 mx-3">
      <div className="text-gray-700">{body}</div>
    </Modal>
  );
};

export default PaymentModal;
